import { Injectable } from '@angular/core';
import { HttpClient, HttpParams,HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorHandlerService, HandleError } from '../config/http-error-handler.service';
import {BaseSvcService} from '../config/base-svc.service';
import { AppOfflineStore } from '../../app.offlineService';
import {SessionService} from '../session.service';
import { ICheckDuplicatePayload } from '../user-management/user-management.service';
export interface GetCodesResponse {
  Code: string;
  Name: string;
  Status: string;
  Display_Order: number;
}
@Injectable({
  providedIn: 'root',
})
export class SubjectManagmentService {
  private handleError: HandleError;
  public url: string;
  public options;

  constructor(
    private http: HttpClient,
    private appserv: AppOfflineStore,
    public httpErrorHandler: HttpErrorHandlerService,
    private config: BaseSvcService,
    public session: SessionService
  ) {
    this.handleError = httpErrorHandler.createHandleError('HeroesService');
    this.url = this.config.activeURL;
    this.options = this.config._httpoption;
  }

  getQuestion(): Observable<any[]> {
    return this.http
      .get<any[]>(this.url + 'api/Question', this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  getstatuscode(): Observable<any[]> {
    return this.http
      .get<any[]>(this.url + 'api/subject/statustype', this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }
  getSubjectTree(data: any): Observable<any[]> {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.MotherTongueLanguage;
    return this.http
      .post<any>(this.url + 'api/GetSubjectTreeNodes', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  DisplayOrderChange(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.MotherTongueLanguage;
    return this.http
      .post(this.url + 'api/UpdateSubjectOrder', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetCode(data: { Tablename: string }): Observable<any[]> {
    return this.http
      .get<{ resultList: any[] }>(
        `${this.url}api/GetCodes/${data.Tablename}`,
        this.options
      )
      .pipe(
        map((response) => response.resultList),
        catchError(this.handleError<any[]>('getQuestion', []))
      );
  }

  getCodes(data: any): Observable<GetCodesResponse[]> {
    return this.http.get<GetCodesResponse[]>(`${this.url}api/getCodes`, {
      params: data,
    });
  }

  getsubjectById(data: any) {
    console.log(data);
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.MotherTongueLanguage;
    let request: any = {
      CurrentNodeSubjectID: Number(data.CurrentNodeSubjectID),
      LoggedInUserID: this.session.getUser(),
      sessionLanguageTypeCode: this.appserv.MotherTongueLanguage,
    };
    return this.http
      .post<any>(this.url + 'api/GetSubjectByID', request, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  getBreadcrumbDetails(data: any): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.url + 'api/GetSubjectNodePathByID/' + data.ID,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }
  getDuplicateNameValidation(data: ICheckDuplicatePayload) {
    data.LoggedInUser = this.session.getUser();
    // data.sessionLanguageTypeCode = this.appserv.MotherTongueLanguage;
    return this.http
      .post<any>(this.url + 'api/GetCheckDuplicate', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  CreateOrModifySubject(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.MotherTongueLanguage;
    return this.http
      .post<any>(this.url + 'api/InsertOrUpdateSubject', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetSubjectRoleAssignmentByID(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.MotherTongueLanguage;
    return this.http
      .post<any>(
        this.url + 'api/GetSubjectRoleAssignmentByID',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetPowerUserByRole(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.MotherTongueLanguage;
    return this.http
      .post<any>(this.url + 'api/GetPowerUserByRole', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  CreateOrModifySubjectRoleAssignment(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.MotherTongueLanguage;
    return this.http
      .post<any>(
        this.url + 'api/InsertOrUpdateSubjectRoleAssignment',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  checkAndUpdateSubjectrelocate(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.MotherTongueLanguage;
    return this.http
      .post<any>(this.url + 'api/GetCheckSubjectRelocation', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetCodeSubject(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.MotherTongueLanguage;
    return this.http
      .get<any[]>(
        this.url + 'api/GetCodesSubject/' + data.Tablename,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  SearchSubjectRoleAssignment(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.MotherTongueLanguage;
    return this.http
      .post<any[]>(
        this.url + 'api/GetSubjectRoleAssignment',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetSubjectRoleTerminationReason(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.MotherTongueLanguage;
    return this.http
      .post<any[]>(
        this.url + 'api/GetSubjectRoleTerminationReason',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  CreateOrRemoveSubjectRoleAssignment(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.MotherTongueLanguage;
    return this.http
      .post<any[]>(
        this.url + 'api/InsertOrUpdateSubjectRoleAssignmentV1',
        data,
        this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  CreateOrModifyQuestionStatus(data: any) {
    data.LoggedInUserID = this.session.getUser();
    data.sessionLanguageTypeCode = this.appserv.MotherTongueLanguage;
    return this.http
      .post(this.url + 'api/InsertOrUpdateQuestionStatus', data, this.options)
      .pipe(catchError(this.handleError('getQuestion', [])));
  }
}

